import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { FeldServiceModule } from '..';
import { FeldSorterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    FeldServiceModule
  ],
  declarations: [FeldSorterComponent],
  exports: [FeldSorterComponent],

})
export class FeldSorterComponentModule { }
